import type { FaireProductEntity } from "../../entity_types/product";

export const p_43fmhb6a87: FaireProductEntity = {
  token: "p_43fmhb6a87",
  type: "product",
  name: "Ubud | Bamboo & Santal",
  brandToken: "b_5gcihcbntu",
  brandName: "Boheme Fragrances",
  imageUrl:
    "https://cdn.faire.com/fastly/f342aaec1cf764aa019987815112b3766c37f054e274e74ed7c14f8630afce94.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f8ce414e38aa76aa98484d785e389439156d846a52b378257ea1116a13cfbde.png",
  ],
  priceDollars: 19,
  description:
    "Inspired by jungle stillness at dawn, warm coconut milk, and the sacred breath of ancient trees, Ubud captures a quiet, contemplative spirit. It is lush, grounding, and gently enveloping.\n\nThis candle blends bamboo leaves and creamy coconut with sandalwood and soft woods for a fragrance that is both verdant and deeply restorative.\n\nFragrance Notes:\nTop — Bamboo\nHeart — Coconut\nBase — Sandalwood, Soft Woods\n\nFeels Like: morning mist in the jungle, bare feet on temple steps.\n\nBring the stillness of Ubud into your everyday rituals.\n\n8oz, 226g, 50 hour burn time\n",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:09.944Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
